exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Gallery-54d41ec6:focus{-moz-outline:none;-webkit-outline:none;outline:none}.mainPhoto-5d76d14d{position:relative;text-align:center;height:675px;max-height:95vh;display:flex;align-items:center;justify-content:center}.mainPhoto-5d76d14d img{flex:1 1;object-fit:contain;max-width:100%;max-height:100%}.filmstrip-2b33db3a{display:flex;flex-wrap:wrap;justify-content:center}.filmstrip-2b33db3a img{margin:3px;opacity:0.5;cursor:pointer;transition:all 0.3s ease}.filmstrip-2b33db3a img:first-child{margin-left:0}.filmstrip-2b33db3a img:hover{opacity:1}.filmstrip-2b33db3a img.selected-8abfd31c{opacity:1}\n", ""]);

// Exports
exports.locals = {
	"Gallery": "Gallery-54d41ec6",
	"mainPhoto": "mainPhoto-5d76d14d",
	"filmstrip": "filmstrip-2b33db3a",
	"selected": "selected-8abfd31c"
};